import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://hcl.policorp.com.br',
});

export default instance;